export default __webpack_public_path__ + "static/quality-v5-c43390ae4b7dcc1f94b6b2e9dad2b090.png";